module.exports = __webpack_public_path__ + "static/media/signal.8ed201a6.svg";